export function getAppBaseUrl(): string {
  const value = process.env.APP_BASE_URL ?? process.env.AUTH_URL ?? ''
  return value.replace(/\/$/, '')
}
